import { Nullable } from 'types';
import type { Analytics } from './analytics';
import { AnalyticsEvent } from './events';
import GTMAnalytics from './gtm';

export default class AnalyticsManager {
  gtmAnalytics: Nullable<Analytics>;

  constructor() {
    this.gtmAnalytics = null;
  }

  init(): void {
    this.gtmAnalytics = new GTMAnalytics();
  }

  track(event: AnalyticsEvent): void {
    this.gtmAnalytics?.track(event);
  }
}
